import { useState, useCallback, useEffect } from "react";
import { Panel, Label } from "@/components/SplitLayout";
import CopyButton from "@/components/CopyButton";
import { ArrowClockwise } from "@phosphor-icons/react";

const makeUuid = () =>
  crypto.randomUUID
    ? crypto.randomUUID()
    : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });

export default function UuidGenerator() {
  const [count, setCount] = useState(5);
  const [upper, setUpper] = useState(false);
  const [list, setList] = useState([]);

  const generate = useCallback(() => {
    const items = Array.from({ length: count }, () => {
      const u = makeUuid();
      return upper ? u.toUpperCase() : u;
    });
    setList(items);
  }, [count, upper]);

  useEffect(() => {
    generate();
  }, [generate]);

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="space-y-6">
        <Panel title="Options">
          <div className="space-y-5">
            <div className="space-y-2">
              <Label>How many</Label>
              <input
                data-testid="uuid-count"
                type="number"
                min={1}
                max={100}
                value={count}
                onChange={(e) => setCount(Math.min(100, Math.max(1, +e.target.value || 1)))}
                className="w-full border border-border bg-card px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <label className="flex items-center gap-3 text-sm">
              <input
                data-testid="uuid-uppercase"
                type="checkbox"
                checked={upper}
                onChange={(e) => setUpper(e.target.checked)}
                className="h-4 w-4 accent-[hsl(var(--primary))]"
              />
              Uppercase
            </label>
            <button
              data-testid="uuid-generate"
              onClick={generate}
              className="inline-flex w-full items-center justify-center gap-2 bg-primary px-5 py-3 text-xs font-bold uppercase tracking-[0.12em] text-primary-foreground transition-transform duration-150 hover:-translate-y-0.5 active:scale-[0.98]"
            >
              <ArrowClockwise size={16} weight="bold" /> Generate
            </button>
          </div>
        </Panel>
      </div>

      <div className="lg:sticky lg:top-24 lg:self-start">
        <Panel
          title={`${list.length} UUID v4`}
          testId="uuid-output"
          action={list.length ? <CopyButton text={list.join("\n")} label="Copy all" /> : null}
        >
          <div className="max-h-[320px] space-y-px overflow-auto">
            {list.map((u, i) => (
              <div
                key={i}
                data-testid={`uuid-row-${i}`}
                className="flex items-center justify-between gap-3 bg-background px-4 py-2.5 font-mono text-sm"
              >
                <span className="truncate">{u}</span>
                <CopyButton text={u} label="" testId={`uuid-copy-${i}`} className="!px-2 !py-1" />
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
}
